import React from 'react';
import {Card, CardTitle, CardText} from 'material-ui/Card';
import {connect} from 'react-redux';
import { withRouter } from 'react-router'
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import {addTag, updateTag, deleteTag} from '../actions/tags';
import TagForm from '../components/TagForm';
import Chip from 'material-ui/Chip';
import {adminCardStyle} from './AdminHomepage';

const Section = ({title, tags, onClick}) => tags.length > 0 && (
  <div>
    <CardTitle subtitle={title} />
    <CardText>
    {
      tags.map((tag) => <Chip key={"tag-" + tag.id} style={{display: 'inline-block', marginRight: 4}} onClick={onClick.bind(null, tag)}>{tag.label}</Chip>)
    }
    </CardText>
  </div>
)

class TagsList extends React.Component {

  state = {
    openTag: false
  }

  render() {
    const {tags} = this.props;
    return  (
      <Card style={adminCardStyle}>
        <CardTitle title="Tags" />
        <Section title="Data Collection" tags={tags.filter((tag) => tag.section === 'monitoring')} onClick={this.handleClick} />
        <Section title="Assessment" tags={tags.filter((tag) => tag.section === 'assessment')} onClick={this.handleClick} />
        <Section title="Management Measures" tags={tags.filter((tag) => tag.section === 'controlRules')} onClick={this.handleClick} />
        <FloatingActionButton secondary={true} style={{position: "fixed", right: "24px", bottom: 24}} onClick={this.handleAddTagClick}>
          <ContentAdd />
        </FloatingActionButton>
        <TagForm open={!!this.state.openTag} {...this.state.openTag} onRequestClose={this.handleRequestClose} onSave={this.handleSaveTag} onDelete={this.handleDelete} />
      </Card>
    );
  }

  handleClick = (tag) => {
    this.setState({openTag: tag});
  }

  handleAddTagClick = () => {
    this.setState({
      openTag: {
        label: "",
        section: "monitoring"
      }
    })
  }

  handleSaveTag = (tag) => {
    this.handleRequestClose();
    if (tag.id) {
      this.props.updateTag(tag);
    } else {
      this.props.addTag(tag);
    }
  }

  handleRequestClose = () => {
    this.setState({openTag: false})
  }

  handleDelete = (id) => {
    this.handleRequestClose();
    this.props.deleteTag(id);
  }

}


let mapStateToProps = (state) => {
  return {
    tags: state.tags.sort((a, b) => a.label.localeCompare(b.label))
  }
}

const mapDispatchToProps = (dispatch) => ({
  addTag: (tag) => dispatch(addTag(tag)),
  updateTag: (tag) => dispatch(updateTag(tag)),
  deleteTag: (id) =>dispatch(deleteTag(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(TagsList));
